interface StringUtils {
  toCamelCase(
    string: string,
    sep: string | RegExp,
    join: string,
    pascal?: boolean,
  ): string;
  format(format: string, ...args: unknown[]): string;
}

const string_utils = {} as StringUtils;

export default string_utils;

string_utils.toCamelCase = function (string, sep, join, pascal) {
  pascal = pascal || false;
  let first = !pascal;
  return string
    .split(sep)
    .map(function (i) {
      const ret = first
        ? i.toLowerCase()
        : i[0].toUpperCase() + i.substring(1).toLowerCase();
      first = false;
      return ret;
    })
    .join(join);
};

string_utils.format = function (format: string): string {
  const args = arguments;
  const formatted = format.replace(/{(\d+)}/g, function (match, number) {
    const index = parseInt(number) + 1;
    const ret = typeof args[index] !== "undefined" ? args[index] : match;
    return ret;
  });
  return formatted;
};
